import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import backend from "../../../../api";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import useFormState from "../../../../utils/useFormState"; 

const AddCharges = () => {
  const { handleSubmit, register, errors } = useForm();

  const [state, setState] = useState();
  const [loading, setLoading] = useState(false);
  const [deliveryCharges, setDeliveryCharges] = useState("");
  const [deliveryLength, setDeliveryLength] = useState(false);
  const [deliveryId, setDeliveryId] = useState("");

  const { user } = useSelector((state) => state.auth);

  // Initialize useFormState with the initial value of deliveryCharges
  const { formValues, handleChange, isButtonDisabled } = useFormState(
    { greeting: "" },
    ""
  );

  useEffect(() => {
    if (user) {
      {
        setLoading(true);
        backend
          .get("/delivery", { params: { merchant_user: user.user._id } })
          .then((response) => {
            setLoading(false);
            setState(response.data.data[0]);
          })
          .catch((error) => {
            setLoading(false);
          });
      }
    }
  }, [user]);

  useEffect(() => {
    if (state) {
      setDeliveryCharges(state.charges);
      setDeliveryId(state._id);
      setDeliveryLength(true);
    } else {
      setDeliveryCharges(0);
      setDeliveryLength(false);
    }
  }, [state]);

  const editHandler = () => {
    const data = {
      merchant_user: user.user._id,
      charges: deliveryCharges,
    };
    if (data) {
      backend
        .put(`/delivery/${deliveryId}`, data)
        .then(({ data: { data, message } }) => {
          setState(data);
          toast.success(message);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    }
  };

  const addHandler = () => {
    const data = {
      merchant_user: user.user._id,
      charges: deliveryCharges,
    };
    if (data) {
      backend
        .post("/delivery", data)
        .then(({ data: { data, message } }) => {
          setState(data);
          toast.success(message);
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | Add Charges</title>
      </Helmet>
      {loading ? (
        <div className="dashboard">
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ClipLoader color={"#000000"} loading={loading} size={60} />
            </div>
          </div>
        </div>
      ) : (
        <div className="dashboard">
          <div className="box-account box-info">
            <div className="box-head">
              <h2>Add Delivery Charges</h2>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12 mx-auto register-page section-b-space">
                <div className="theme-card">
                  <form className="theme-form">
                    <div className="form-row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="deliveryCharges">
                            Delivery charges
                          </label>
                          <input
                            type="text"
                            className="form-control mb-0"
                            id="deliveryCharges"
                            name="greeting"
                            placeholder="Delivery Charges. (USD)"
                            value={formValues.greeting}
                            onChange={(e) => {
                              handleChange(e);
                              setDeliveryCharges(e.target.value); // update delivery charges
                            }}
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          <label htmlFor="deliveryCharges" className="error">
                            {errors.deliveryCharges &&
                              errors.deliveryCharges.message}
                          </label>
                        </div>
                      </div>
                    </div>

                    {deliveryLength === false ? (
                      <div className="row justify-content-end">
                        <button
                          type="button"
                          className="btn btn-solid ml-auto"
                          onClick={handleSubmit(addHandler)}
                          disabled={isButtonDisabled}
                        >
                          ADD Charges
                        </button>
                      </div>
                    ) : (
                      <div className="row justify-content-end">
                        <button
                          type="button"
                          className="btn btn-solid ml-auto"
                          onClick={handleSubmit(editHandler)}
                          disabled={isButtonDisabled}
                        >
                          Edit Charges
                        </button>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddCharges;
